<template>
  <div class="flex flex-col overflow-auto bg-white  w-[50vw] h-[50vh]">
    <div class="flex bg-primary">
      <div class="flex flex-col overflow-hidden object-contain w-full">
        <h2 class="px-4 text-2xl mb-4">History Informationen</h2>
        <div v-if="historyInfo" class="p-4 overflow-x-auto w-full" data-ui="history-elements">

          <template v-for="(item, index) in historyInfo" :key="index" >

            <!-- For debugging -->
            <!-- <div class="bg-yellow-300">{{ item }}</div> -->
            <div class="grid grid-cols-2 gap-2 mb-4 border-b pb-1 border rounded-lg shadow-sm px-4 py-2  ">
              <!-- Erste Zeile -->
              <div class="  whitespace-nowrap font-bold">
                {{ formatDate(item.historyTime) }}
              </div>
              <div class=" ">
                <span class="whitespace-nowrap font-bold ">{{ fixEncoding(item.username) }}</span>
              </div>


              <div class="w-1/2 pb-2" data-ui="fieldName"> {{ translate(item.fieldName) }}</div>
              
              <!-- Inaktiv / Aktiv -->

                <div v-if="key(item.fieldName) == 'visibility'" class="w-full flex flex-col">
                  <img :src='item.filename' class="max-w-[70px] max-h-[70px] object-contain">
                  <div v-if="item.oldValue == 'no'">Bild/Logo wurde aktiv gestellt.</div>
                  <div v-else>Bild/Logo wurde inaktiv gestellt.</div>
                </div>

                <!-- Neues Bild -->
                <div v-else-if="key(item.fieldName) == 'new_image'" class="w-full flex flex-col">
                  <img :src='item.filename' class="max-w-[70px] max-h-[50px] object-contain">
                </div>

                <!-- Position wurde geändert -->
                <div v-else-if="key(item.fieldName) == 'changeposition'" class="w-full flex flex-col">
                  <img :src='item.filename' class="max-w-[70px] max-h-[50px] object-contain ">
                  <div>Alte Position: {{ item.oldValue }}</div>
                  <div>Neue Position: {{ item.newValue }}</div>
                </div>

                <!-- Bild wurde gelöscht -->
                <div v-else-if="key(item.fieldName) == 'deletepicture'" class="w-full flex flex-col">
                  <img :src='item.filename' class="max-w-[70px] max-h-[50px] object-contain">
                </div>

                <!-- Logo wurde gelöscht -->
                <div v-else-if="key(item.fieldName) == 'deletelogo'" class="w-full flex flex-col">
                  <img :src='item.filename' class="max-w-[70px] max-h-[50px] object-contain">
                </div>

                <!-- Default (else) Case -->
                <div v-else class="flex gap-2">
                  <p :data-ui="'oldValue' + index">{{ item.oldValue }}</p>
                  <span><i class="fa-solid fa-arrow-right"></i></span>
                  <p :data-ui="'newValue' + index">{{ item.newValue }}</p>
                </div>



            </div>

          </template>
        </div>
      </div>
    </div>
    <div class="w-full h-full  justify-center flex flex-col">
      <div v-if="noHistory" class="text-center ">
        <span class="text-xl">Sie haben keine seite ausgewählt</span>
      </div>
    </div>

  </div>
</template>

<script>
import {gql} from "@apollo/client/core";
import apolloClient from "@/apolloClient";

const translationMap = {
  "deletepicture": "Bild wurde gelöscht", //
  "ppicture": "Bild wurde hinzugefügt",  // scheiße
  "deletelogo": "Logo wurde gelöscht",
  "plogo": "Logo wurde hinzugefügt",
  "changeposition": "Position wurde geändert",  //"type": "logo"
  "new_image": "Bild/Logo wurde hinzugefügt",
  "visibility": "Sichtbarkeit wurde geändert",
};
export default {
  name: "History.vue",
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      historyInfo: [],
      noHistory: false,
      labels: [],
      fields: [],
    }
  },
  created() {
    // Die search-Methode wird beim Erstellen der Komponente aufgerufen
    this.search();
    this.getFieldLabel();
  },
  methods: {
    async getFieldLabel() {

      const response = await apolloClient.query({
        query: gql`
            query  getFieldLabel {
              getFieldLabel{
                id
                label
                field
              }
            }
          `,
      });
      try {

        response.data.getFieldLabel.forEach((item) => {
          this.labels.push(item.label);
          this.fields.push(item.field);
        });

        for (let i = 0; i < this.fields.length; i++) {
          translationMap[this.fields[i].toLowerCase()] = this.labels[i];
        }

        

      } catch (error) {
        console.error("Fehler beim Abrufen der getFormularInfos:", error);
      }
    },
    search: async function () {


      if (this.value.pageId == null) {
        this.noHistory = true;
      }

      const query = gql`
        query GetHistory($pageId: Int!, $productId: Int!) {
          activityHistory(pageId: $pageId, productId: $productId) {
            historyId
            historyTime
            historyIdPage
            historyIdProdukt
            username
            historyData
            type
            fieldName
            oldData
            newData
            oldValue
            newValue
            filename
            created
            modified
            name
            value
          }
        }
      `;
      const variables = {
        pageId: this.value.pageId,
        productId: this.value.productId
      };
      try {
        const {data} = await apolloClient.query({query, variables});
        this.historyInfo = data.activityHistory; // Hier werden die Daten in historyInfo gespeichert
      } catch (error) {
        console.error("Fehler beim Ausführen der GraphQL-Abfrage:", error.message);
      }
    },
    fixEncoding(str) {
      try {
        let decoder = new TextDecoder('UTF-8');
        let encoder = new TextEncoder(); // UTF-8 is the default encoding
        return decoder.decode(encoder.encode(str));
      } catch (error) {
        console.warn("Fehler beim Fixieren der Kodierung:", error.message);
        return str;  // Im Fehlerfall geben Sie einfach den Originalstring zurück.
      }
    },
    formatDate(unixTimestamp) {
      const date = new Date(unixTimestamp * 1000); // Das Multiplizieren mit 1000 ist notwendig, da JavaScript Millisekunden erwartet.
      return date.toLocaleString(); // Dies gibt das Datum und die Uhrzeit in einem lokalisierten Format zurück.
    },
    key(str) {
      const fixed = str.replace(/\s/g, '_').toLowerCase();
      return fixed;
    },
    translate(str) {
      const fixed = str.replace(/\s/g, '_').toLowerCase();
      
      return translationMap[fixed] || str; // Falls keine Übersetzung gefunden wird, wird der Originalstring zurückgegeben
    }
  }
};
</script>